import { AsyncUserListHandler } from "@/components/AsyncComponents"

export const withUserList = (WrappedComponent: any) => {
    return {
        template: `<Handler><WrappedComponent></WrappedComponent></Handler>`,
        components: {
            WrappedComponent,
            Handler: AsyncUserListHandler
        },
    }
}